import reducer from "./reducers/reducer";
import httpsMiddleware from "./middlewares/httpsMiddleware"
import settingsMiddleware from "./middlewares/settingsMiddleware";
import validateAgentMiddleware from "./middlewares/validateAgentMiddleware";
import {registerMiddleware, registerReducer} from "../../store";


registerMiddleware("connectorSettingsHttps", httpsMiddleware);
registerMiddleware("connectorSettingsConfig", settingsMiddleware);
registerMiddleware("connectorSettingsValidateAgent", validateAgentMiddleware);

registerReducer("connectorSettings", reducer);

export {default as Settings} from "./components/settings/Settings";
export { default as HttpsSetup } from "./components/https/HttpsSetup";
export { default as ValidateAgentDashboard } from "./components/validate-agent/ValidateAgentDashboard";